import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import styled from 'styled-components'
import {DefaultBlockConfigValues} from 'TemplateEditor/Layout/Blocks/DefaultBlockConfig'
import {DefaultBlockHolder} from 'TemplateEditor/Layout/Blocks/DefaultBlockHolder'
import {PreviewHolderDiv} from 'TemplateEditor/Layout/Sidebar/BlocksList'
import {Section} from 'TemplateEditor/template'
import {v4 as uuidv4} from 'uuid'
import AddToQueueIcon from '@mui/icons-material/AddToQueue'
import {useFunctions} from 'TemplateEditor/FunctionsProvider'
import {ButtonOneConfigType} from 'TemplateEditor/Layout/Blocks/ButtonOne/ButtonOne'

export const ButtonJoinTypeId = 'block-button-join'

type ButtonJoinProps = {
  block: ButtonJoinConfigType
  section: Section
  setEditMode: () => void
  key: string | number
  editMode: boolean
}

export function ButtonJoin(props: ButtonJoinProps) {
  const {block, setEditMode, editMode} = props
  const {joinMeeting} = useFunctions()

  const handleClick = () => {
    if (editMode) return

    if (joinMeeting) {
      joinMeeting.join()
    }
  }

  return (
    <DefaultBlockHolder block={block} key={props.key} onClick={setEditMode}>
      <>
        {!props.block.text && <PreviewButtonJoin />}
        {props.block.text && (
          <DefaultButton block={block} onClick={handleClick}>
            {props.block.text}
          </DefaultButton>
        )}
      </>
    </DefaultBlockHolder>
  )
}

export function PreviewButtonJoin() {
  const {t} = useI18n()
  return (
    <PreviewHolderDiv>
      <AddToQueueIcon />
      <span>{t('templateEditor.blockJoin')}</span>
    </PreviewHolderDiv>
  )
}

export type ButtonJoinConfigType = Omit<
  ButtonOneConfigType,
  'link' | 'linkType'
>

export function newButtonJoin(): ButtonJoinConfigType {
  return {
    ...DefaultBlockConfigValues(),
    id: uuidv4(),
    type: ButtonJoinTypeId,
    backgroundColor: '#ffffff',
    textColor: '#333333',
    text: '',
    textAlign: 'left',
    font: 'Comfortaa',
    width: 100,
    height: 50,
    fontSize: 1.5,
    mobile: {
      ...DefaultBlockConfigValues().mobile,
      width: 100,
      fontSize: 1.5,
      height: 50,
    },
  }
}

const DefaultButton = styled.div<{
  block: ButtonJoinConfigType
}>`
  background: ${(props) => props.block.backgroundColor};
  color: ${(props) => props.block.textColor};
  width: ${(props) => props.block.width}%;
  height: ${(props) => props.block.height}px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${(props) => props.block.font};
  cursor: pointer;
  border-radius: ${(props) => props.block.border.radius}px;
  border-width: ${(props) => props.block.border.width}px;
  border-color: ${(props) => props.block.border.color};
  border-style: solid;
  font-size: ${(props) => props.block.fontSize}rem;
  text-align: ${(props) => props.block.textAlign};

  @container (max-width: 991px) {
    width: ${(props) => props.block.mobile.width}%;
    height: ${(props) => props.block.mobile.height}px;
    font-size: ${(props) => props.block.mobile.fontSize}rem;
  }
`
